module.exports = __webpack_public_path__ + "images/aef3f2ecdb09fa325d8528fa34a7c4dd-kitchen_drawers2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/content/kitchen_drawers2.jpg
// module id = ./src/assets/images/content/kitchen_drawers2.jpg
// module chunks = 0